import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, provideApiBaseUrl, SITES_PROVIDER } from '@privaci/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { SitesService } from './features/sites/sites.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideApiBaseUrl(environment.apiUrl),
    // Lets @privaci/core's shell guards (onboardingGuard, firstSiteRedirectGuard) check "does
    // this user have sites" without the library depending on this app's concrete SitesService.
    { provide: SITES_PROVIDER, useExisting: SitesService },
  ]
};
